<template>
  <div >

    <div >
        <p>télécharger le modèle de <a href="/template.xlsx">fichier excel</a> </p>
        <input type="file" id="file_upload" @change="upload" />
        <!-- table -->
        <div class="table-responsive" v-if="products.length" style="max-height:500px">
            <div style="margin-top:1rem;margin-bottom:1rem"><b>{{products.length}}</b> produits trouvée.</div>
            <table class="table mb-0 table-borderless table-striped small">

                <thead>
                    <tr class="text-secondary">
                        <th class="pt-4 pb-3 px-6">{{$t('label')}}<span class="required">*</span></th>
                        <th class="pt-4 pb-3 px-6">{{$t('quantity')}}<span class="required">*</span></th>
                        <th class="pt-4 pb-3 px-6">{{$t('purchase_price')}}<span class="required">*</span></th>
                        <th class="pt-4 pb-3 px-6">{{$t('price')}}<span class="required">*</span></th>
                        <th class="pt-4 pb-3 px-6">{{$t('sku')}}</th>
                        <th class="pt-4 pb-3 px-6">{{$t('created_at')}}</th>
                    </tr>
                </thead>

                <tbody>

                    <tr v-for="(product,i) in products" :key="product.id">
                        <td class="py-5 px-6"><input type="text" :placeholder="$t('label')" v-model="products[i].label"> </td>
                        <td class="py-5 px-6"><input type="number" :placeholder="$t('quantity')" v-model="products[i].quantity" ></td>
                        <td class="py-5 px-6"><input type="number" :placeholder="$t('price')" v-model="products[i].price"></td>
                        <td class="py-5 px-6"><input type="number" :placeholder="$t('purchase_price')" v-model="products[i].purchase_price"></td>
                        <td class="py-5 px-6"><input type="text" :placeholder="$t('sku')" v-model="products[i].sku"></td>
                        <td class="py-5 px-6"><input type="text" :placeholder="$t('created_at')" v-model="products[i].created_at"></td>
                    </tr>

                </tbody>
            </table>
            <button class="btn btn-success btn-block mt-4" style="width:100%" @click="saveRow" :disabled="loading"><AppIcon name="bi-check-circle" class="bi bi-check-circle me-2" />{{$t('save')}}</button>
        </div>
        <!-- table -->
      </div>

  </div>
</template>

<script>
import { read,utils } from "xlsx";
import helper from '../helper'
export default {
  name: 'ImportProduct',
  data(){
    return {
        products : [],
        loading : false
    }
  },
  methods : {
    upload() {
        var files = document.getElementById('file_upload').files;
        if(files.length==0){
          alert("Please choose any file...");
          return;
        }

        var filename = files[0].name;
        var extension = filename.substring(filename.lastIndexOf(".")).toUpperCase();
        if (extension == '.XLS' || extension == '.XLSX') {
            this.excelFileToJSON(files[0]);
        }else{
            alert("Veuillez sélectionner un fichier Excel valide.");
        }
    },
    excelDateToJSDate(excelDate) {
        return new Date((excelDate - 25569) * 86400 * 1000);
    },
    excelFileToJSON(file){
        try {
            var reader = new FileReader();
            reader.readAsBinaryString(file);
            reader.onload = (e) => {

                var data = e.target.result;
                var workbook = read(data, {
                    type : 'binary'
                });
                workbook.SheetNames.forEach((sheetName) => {
                var roa = utils.sheet_to_row_object_array(workbook.Sheets[sheetName]);
                for(let i = 0 ; i < roa.length ; i++){
                    
                    let label = "",
                        price= 0,
                        purchase_price = 0,
                        sku = null,
                        created_at=null,
                        quantity  = 0;

                    //searching for product name
                    if(roa[i].label){
                       label = roa[i].label
                    }

                    //searching for product price
                    if(roa[i].price){
                        price = roa[i].price ? roa[i].price : 0
                    }

                    if(roa[i].created_at){
                        created_at = this.excelDateToJSDate(roa[i].created_at)
                    }

                    //searching for product price
                    if(roa[i].purchase_price){
                        purchase_price = roa[i].purchase_price ? roa[i].purchase_price : 0
                    }

                    //searching for sku
                    if(roa[i].sku){
                        sku = roa[i].sku
                    }

                    //quantity
                    if(roa[i].quantity){
                        quantity = roa[i].quantity ? roa[i].quantity : 0
                    }

                    this.products.push({
                        label,
                        price,
                        purchase_price,
                        sku,
                        created_at,
                        quantity
                    })
                }   

              });

            }
        }catch(e){
          window._errors = e
        }
    },
    async saveRow(){
        try{
           
            this.loading = true;
            await helper.customPost(`${process.env.VUE_APP_API}/products/bulk`,{products: this.products},{showToast:true})
            this.products = []
            this.loading = false;
            
        }catch(error){
            this.loading = false;
        }

    },
  }
}
</script>

<style scoped>
    .table-borderless>:not(caption)>*>*{
        padding: 5px !important
    }
</style>